import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ChatStore } from '../../services/chat.store';

/**
 * The ringing banner: "Sarah is calling", with Join and Ignore.
 *
 * Mounted in the app shell rather than inside the chat widget, and deliberately outside the
 * launcher's `!onChatPage` guard — a call has to reach you wherever you are in the app, including
 * on the full chat page, and including when the widget is closed.
 *
 * Everything it shows comes from {@link ChatStore.incomingCall}, which is the client's own reading
 * of a message that carried a call link. There is no call event on the wire, so this is the only
 * place the distinction between "a message arrived" and "someone is calling" exists.
 */
@Component({
  selector: 'app-chat-incoming-call',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chat-incoming-call.component.html',
  styleUrls: ['./chat-incoming-call.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatIncomingCallComponent {
  readonly store = inject(ChatStore);
}
